<template>
  <div class="brief-score-card-main-container">
    <div class="brief-score-card__team">
      <Icon :logoUrl="data.homeLogo" hasClass="match-detail-team-icon"></Icon>
    </div>
    <div class="brief-score-card-container" v-if="data.matchState === 0">
      <div class="brief-score-home-team time-slot">
        {{ data.matchStatus }}
      </div>
    </div>
    <div class="brief-score-card-container" v-else>
      <div class="brief-score-home-team score-slot">
        <!-- {{
          data.homeTeamPenaltyScore !== null
            ? data.homeTeamPenaltyScore
            : data.homeTeamScore
        }} -->
        {{ data.containExtraTime ? 
            data.homeTeamExtraTimeScore : 
            data.homeTeamScore ? 
            data.homeTeamScore : 
            '-' }}
      </div>
      <div class="brief-score-divider">-</div>
      <div class="brief-score-away-team score-slot">
        <!-- {{
          data.awayTeamPenaltyScore !== null
            ? data.awayTeamPenaltyScore
            : data.awayTeamScore
        }} -->
        {{ data.containExtraTime ? 
            data.awayTeamExtraTimeScore : 
            data.awayTeamScore ? 
            data.awayTeamScore : 
            '-' }}
      </div>
    </div>
    <div class="brief-score-card__team">
      <Icon :logoUrl="data.awayLogo" hasClass="match-detail-team-icon"></Icon>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: null,
    },
  },
};
</script>

<style scoped>
.brief-score-card-main-container {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  position: relative;
  top: 5px;
}
.brief-score-card__team {
}
.brief-score-card-container {
  display: flex;
  justify-content: space-evenly;
  height: 1.25rem;
}
.score-slot,
.brief-score-divider {
  width: 1.5rem;
  color: var(--color-text-default-default);
  text-align: center;

  /* Body Small Strong */
  font-family: var(--typography-body-font-family);
  font-size: var(--typography-body-size-small);
  font-style: normal;
  font-family: var(--weight-700);
  line-height: 140%; /* 19.6px */
  letter-spacing: 0.64px;
}
.time-slot {
  width: 80px;
  text-align: center;
  color: var(--color-text-default-default);
  font-size: 14px;
  font-family: var(--weight-600);
	letter-spacing: 0.64px;
}
.match-detail-team-icon {
  width: var(--size-icon-small);
  height: var(--size-icon-small);
}
</style>
